<template>
  <div>
    <div class="container mt-5 mb-5 pb-5 emp-seatlayout header-space">
      <div class="col-md-12 px-0">
        <div class="mb-3 seatlayout-timer">
          <div class="centerTitle">
            <span class="red-dotl"></span>
            <div class="d-flex justify-content-center align-items-center">
              <p class="title ar-number mx-1">
                {{ this.timer.minutes }}:{{ this.timer.seconds }}
              </p>
              <p class="text ml-1 ml-md-3">
                <span class="d-block">{{ allLanguageData.Timer[0] }}</span>
                {{ allLanguageData.Timer[1] }}
              </p>
            </div>
            <span class="red-dotr"></span>
          </div>
        </div>
        <div
          class="text-center font-weight-bold mt-4 mb-3"
          style="color: #434345; letter-spacing: 1.2px"
        >
          {{ allLanguageData.GrabABite }}
        </div>
        <div class="fnb-section">
          <div class="screen-header fnb-header mx-0 py-4 px-2 px-lg-5 mt-n1">
            <div class="screen-tabs mx-auto">
              <ul class="list-inline my-0 py-0">
                <li class="list-inline-item">
                  <a
                    class="item-link"
                    id="slick-0"
                    @click="getTitleIndex('all')"
                    :style="FnbSelected == 'all' ? 'color:red !important' : ''"
                    >{{ allLanguageData.All }}</a
                  >
                </li>
                <!-- First it was fnbItemDataTemp instead of fnbItemData for category heading-->
                <li
                  v-for="(data, index) in fnbItemDataTemp"
                  :key="index"
                  class="list-inline-item"
                >
                  <a
                    class="item-link ar-number"
                    :id="`slick-${index + 1}`"
                    @click="getTitleIndex(data.Id, data)"
                    :style="
                      FnbSelected == data.Id ? 'color:red !important' : ''
                    "
                  >
                    {{
                      getCurrentLang().brij_lang_id == 1
                        ? data.Title
                        : data.alternate_language
                        ? data.alternate_language
                        : data.Title
                    }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="fnb-content">
            <div
              v-for="(data, index) in filterdfnbItemData"
              :key="index"
              class="my-4 pt-2"
              ref="fnbSliderWrapper"
            >
              <div
                class="fnb-title py-3 pl-3 ar-number test123"
                :style="
                  langName == `ar` && data.alternate_language
                    ? 'text-align:end; display:flex; padding:20px'
                    : ''
                "
              >
                <!-- {{ data.Title }}  -->
                {{
                  getCurrentLang().brij_lang_id == 1
                    ? data.Title
                    : data.alternate_language
                    ? data.alternate_language
                    : data.Title
                }}
              </div>

              <div
                v-if="!fnbloading && data.groupedItems.length == 1"
                class="fnb-items empire-slider fnb-slider mt-4"
              >
                <!--Start Slider-->
                <slick
                  @reInit="handleReInit"
                  :ref="'fnbSlider' + index"
                  :options="fnbSliderOptions()"
                  :id="'fnbSlider' + data.Id"
                  class="fnbSlider"
                >
                  <div
                    v-for="(dataItems, indexitems) in data.items"
                    :key="indexitems"
                  >
                    <div class="fnb-card py-3" :title="dataItems.Description">
                      <div class="fnb-img d-flex justify-content-center">
                        <img
                          v-if="dataItems.ThumbnailImage"
                          :src="dataItems.ThumbnailImage"
                          class="image img-fluid"
                          alt=""
                        />
                        <img
                          v-else
                          src="@/assets/img/dummy_img.png"
                          class="image img-fluid"
                        />
                      </div>
                      <div class="fnb-content pt-2">
                        <p
                          class="main-title ar-number"
                          :style="
                            langName == 'ar' && dataItems.alternate_item_name
                              ? 'text-align:end'
                              : ''
                          "
                        >
                          <!-- {{
                            langName == "ar"
                              ? dataItems.alternate_item_name
                              : dataItems.alternate_item_name
                              ? dataItems.ItemName
                              : dataItems.ItemName
                          }} -->
                          {{
                            langName == "ar" && dataItems.alternate_item_name
                              ? dataItems.alternate_item_name
                              : dataItems.ItemName
                          }}
                          <!-- &nbsp;{{
                            dataItems.FnbDetail.is_premier_item
                          }}
                          &nbsp;{{ dataItems.Qty }} -->
                        </p>
                        <div class="grid-half">
                          <div class="fnb-amt ar-number">
                            <!-- {{ dataItems.Currency }} -->
                            <span v-html="dataItems.Currency"></span>
                            {{ currFormat(dataItems.Amount) }}
                          </div>
                          <div
                            class="qty 123"
                            v-if="!dataItems.showSelectedBtnOnAlternativeItem"
                          >
                            <div
                              class="icon"
                              @click="
                                storeFnbItems(
                                  dataItems,
                                  'sub',
                                  dataItems.fnbItemDataIndex,
                                  dataItems.fnbItemDataItemsIndex
                                )
                              "
                            >
                              <a> -</a>
                            </div>
                            <div class="num ar-number">{{ dataItems.Qty }}</div>
                            <div
                              class="icon"
                              @click="
                                storeFnbItems(
                                  dataItems,
                                  'add',
                                  dataItems.fnbItemDataIndex,
                                  dataItems.fnbItemDataItemsIndex
                                )
                              "
                            >
                              <a> +</a>
                            </div>
                          </div>
                          <div v-else class="" style="text-align: right">
                            <button
                              class="selected_alternative_btn"
                              @click="
                                storeFnbItems(
                                  dataItems,
                                  'add',
                                  dataItems.fnbItemDataIndex,
                                  dataItems.fnbItemDataItemsIndex
                                )
                              "
                            >
                              Selected
                            </button>
                          </div>
                        </div>

                        <div class="" style="margin-top: 5px">
                          <div
                            class="fnb-amt ar-number"
                            style="
                              white-space: nowrap;
                              margin-top: 12px;
                              width: auto;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            {{
                              langName == "ar"
                                ? dataItems.alternate_item_name
                                : dataItems.Description
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </slick>
                <!--End Slider-->
              </div>

              <div
                v-if="!fnbloading && data.groupedItems.length > 1"
                class="fnb-items empire-slider fnb-slider mt-4"
              >
                <!--Start Slider-->
                <slick
                  @reInit="handleReInit"
                  :ref="'fnbSlider' + index"
                  :options="fnbSliderOptions()"
                  :id="'fnbSlider' + data.Id"
                  class="fnbSlider"
                >
                  <div
                    v-for="(group, indexitems) in data.groupedItems.filter(
                      g => g.fc_parent_id != 0
                    )"
                    :key="indexitems"
                  >
                    <div
                      class="fnb-card py-3"
                      @click="
                        selectCategoryGroup(
                          group,
                          group.groupedItemsIndex,
                          data.groupedItems
                        )
                      "
                      :title="`${group.fc_category} - ${group.p_fc_category}`"
                    >
                      <div class="fnb-img d-flex justify-content-center">
                        <img
                          v-if="
                            group.items[0].FnbDetail.fc_icon_url != null ||
                              group.items[0].FnbDetail.p_fc_icon_url != null
                          "
                          :src="
                            checkBaseUrl(
                              getSafe(
                                () =>
                                  group.items[0].FnbDetail.fc_icon_url ||
                                  group.items[0].FnbDetail.p_fc_icon_url
                              )
                            )
                          "
                          class="image img-fluid"
                        />
                        <img
                          v-else
                          src="@/assets/img/dummy_img.png"
                          class="image img-fluid"
                        />
                      </div>
                      <div class="fnb-content pt-2">
                        <p class="main-title ar-number">
                          {{ `${group.fc_category || group.p_fc_category}` }}
                        </p>
                        <div class="grid-half">
                          <div class="fnb-amt ar-number">
                            <!-- Starting {{ group.items[0].Currency }} -->
                            <span v-html="group.items[0].Currency"></span>
                            {{ currFormat(group.items[0].Amount) }}
                          </div>
                          <div class="qty 456">
                            <div class="icon__">
                              <a></a>
                            </div>
                            <div class="num ar-number"></div>
                            <div class="icon__">
                              <a></a>
                            </div>
                          </div>
                        </div>

                        <div class="" style="margin-top: 5px">
                          <div
                            class="fnb-amt ar-number"
                            style="
                              white-space: nowrap;
                              margin-top: 12px;
                              width: auto;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            &nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-for="(dataItems, indexitems) in getSafe(
                      () =>
                        data.groupedItems.filter(g => g.fc_parent_id == 0)[0]
                          .items,
                      []
                    )"
                    :key="indexitems + 9999"
                  >
                    <div class="fnb-card py-3" :title="dataItems.Description">
                      <div class="fnb-img d-flex justify-content-center">
                        <img
                          v-if="dataItems.ThumbnailImage"
                          :src="dataItems.ThumbnailImage"
                          class="image img-fluid"
                        />
                        <img
                          v-else
                          src="@/assets/img/dummy_img.png"
                          class="image img-fluid"
                        />
                      </div>
                      <div class="fnb-content pt-2">
                        <p class="main-title ar-number two">
                          {{ dataItems.ItemName }}
                        </p>
                        <div class="grid-half">
                          <div class="fnb-amt ar-number">
                            <!-- {{ dataItems.Currency }} -->
                            <span v-html="dataItems.Currency"></span>
                            {{ currFormat(dataItems.Amount) }}
                          </div>
                          <div class="qty 789">
                            <div
                              class="icon"
                              @click="
                                storeFnbItems(
                                  dataItems,
                                  'sub',
                                  dataItems.fnbItemDataIndex,
                                  dataItems.fnbItemDataItemsIndex
                                )
                              "
                            >
                              <a> -</a>
                            </div>
                            <div class="num ar-number">{{ dataItems.Qty }}</div>
                            <div
                              class="icon"
                              @click="
                                storeFnbItems(
                                  dataItems,
                                  'add',
                                  dataItems.fnbItemDataIndex,
                                  dataItems.fnbItemDataItemsIndex
                                )
                              "
                            >
                              <a> +</a>
                            </div>
                          </div>
                        </div>

                        <div class="" style="margin-top: 5px">
                          <div
                            class="fnb-amt ar-number"
                            style="
                              white-space: nowrap;
                              margin-top: 12px;
                              width: auto;
                              overflow: hidden;
                              text-overflow: ellipsis;
                            "
                          >
                            {{ dataItems.Description }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </slick>
                <!--End Offer Slider-->
              </div>
            </div>

            <div class="mb-5 pb-5"></div>
          </div>
        </div>
      </div>
    </div>

    <!--Desktop Checkout Grid-->
    <div class="container-fluid checkout-fixed py-4 d-none d-md-block">
      <div class="col-lg-12 mx-auto">
        <div class="align-items-center checkout-grid">
          <div class="text-right" @click="goBack()">
            <img
              src="@/assets/img/new-img/svg-img/back-arrow.svg"
              class=""
              width="40px"
            />
          </div>
          <div class="vertical-line">
            <hr class="vertical" />
          </div>
          <div>
            <div class="grid-half">
              <ul class="mb-0 px-0 checkout-list" style="color:#fff">
                <li class="pb-2">
                  {{ allLanguageData.Movie }}: {{ scheduleData.MovieTitle }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Screen }}: {{ scheduleData.ScreenName }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Date }}: {{ scheduleData.ShowDate }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Time }}: {{ scheduleData.ShowTime }}
                </li>
              </ul>
              <ul
                class="mb-0 px-0 checkout-list"
                style="color: #fff !important;"
              >
                <li class="pb-2">
                  {{ allLanguageData.Location }}: {{ scheduleData.CinameName }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Experience }}:
                  {{ scheduleData.Experience }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Seats }}:
                  <template
                    v-if="normal_seats.length"
                    v-for="seatObj in normal_seats"
                  >
                    <span
                      class="ar-number"
                      :key="seatObj.sst_seat_type + '3'"
                      v-if="seatObj.seatName.length"
                      >{{ seatObj.sst_seat_type }} -
                      {{ seatObj.seatName.join(", ") }} </span
                    ><br
                      :key="seatObj.sst_seat_type + '2'"
                      v-if="seatObj.seatName.length"
                    />
                    <span
                      class="ar-number"
                      v-if="seatObj.wheelChair.length"
                      :key="seatObj.sst_seat_type + '4'"
                      >{{ seatObj.sst_seat_type }} Wheel Chair -
                      {{ seatObj.wheelChair.join(", ") }} </span
                    ><br
                      :key="seatObj.sst_seat_type + '5'"
                      v-if="seatObj.wheelChair.length"
                    />
                  </template>
                </li>
              </ul>
            </div>
            <div class="fnb-half">
              <ul
                class="mb-0 px-0 checkout-list"
                style="color: #fff !important;"
              >
                <li v-if="userSelectedFnBItems.length > 0" class="pb-1">
                  {{ allLanguageData.FoodDrinks }}: &nbsp;
                </li>
              </ul>
              <div class="d-flex flex-wrap">
                <div
                  v-for="(datafnb, indexf) in userSelectedFnBItems"
                  :key="indexf"
                  class="pb-1 food-list"
                >
                  ( {{ datafnb.Qty }} X {{ datafnb.ItemName }} )
                </div>
                <div
                  class=""
                  style="cursor: pointer;"
                  v-if="userSelectedFnBItems && userSelectedFnBItems.length > 0"
                  @click="clearAllFnbItems"
                >
                  <span class="cross_fnb_items">&#10006;</span>&nbsp;Clear
                </div>
              </div>
            </div>
          </div>
          <div class="vertical-line">
            <hr class="vertical" />
          </div>
          <div>
            {{ allLanguageData.Total }} :
            <span class="ar-number">
              <!-- {{ scheduleData.Currency }}  -->
              <span v-html="scheduleData.Currency"></span>
              {{ currFormat(totalAmount) }}</span
            >
          </div>
          <div class="vertical-line">
            <hr class="vertical" />
          </div>
          <div>
            <button
              v-if="userSelectedFnBItems.length > 0"
              class="btn btn-checkout"
              @click="onSubmitfnbCheckOut"
            >
              {{ allLanguageData.Proceed }}
            </button>
            <button v-else class="btn btn-checkout" @click="skipFNB">
              {{ allLanguageData.Skip }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Mobile Checkout Grid-->
    <div class="container-fluid checkout-fixed py-4 d-block d-md-none">
      <div class="col-lg-12 px-0 mx-auto">
        <div
          class="align-items-center pt-3 animate__animated animate__pulse"
          :class="displayContent ? 'd-block' : 'd-none'"
        >
          <div class="mt-5">
            <ul class="info-list">
              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Movie }}:</strong>
                <span>{{ scheduleData.MovieTitle }}</span>
              </li>

              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Screen }}:</strong>
                <span>{{ scheduleData.ScreenName }}</span>
              </li>

              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Date }}:</strong>
                <span>{{ scheduleData.ShowDate }}</span>
              </li>

              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Time }}:</strong>
                <span>{{ scheduleData.ShowTime }}</span>
              </li>
            </ul>

            <ul class="info-list">
              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Location }}:</strong>
                <span>{{ scheduleData.CinameName }}</span>
              </li>

              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Experience }}:</strong>
                <span>{{ scheduleData.Experience }}</span>
              </li>

              <li>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                    fill="#5CC82A"
                  />
                </svg>
                <strong>{{ allLanguageData.Seats }}: </strong>
                <template
                  v-if="normal_seats.length"
                  v-for="seatObj in normal_seats"
                >
                  <span
                    class="ar-number"
                    :key="seatObj.sst_seat_type + '3'"
                    v-if="seatObj.seatName.length"
                    >{{ seatObj.sst_seat_type }} -
                    {{ seatObj.seatName.join(", ") }} </span
                  ><br
                    :key="seatObj.sst_seat_type + '2'"
                    v-if="seatObj.seatName.length"
                  />
                  <span
                    class="ar-number"
                    v-if="seatObj.wheelChair.length"
                    :key="seatObj.sst_seat_type + '4'"
                    >{{ seatObj.sst_seat_type }} Wheel Chair -
                    {{ seatObj.wheelChair.join(", ") }} </span
                  ><br
                    :key="seatObj.sst_seat_type + '5'"
                    v-if="seatObj.wheelChair.length"
                  />
                </template>
                >
              </li>

              <li class="seating-tick">
                <hr class="m-0 fade-line no-hover-effect" />
                <div class="py-3">
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.2492 0.703125L4.75078 7.95234L1.5 4.70391L0 6.20391L4.99922 11.2031L12 2.20312L10.2492 0.703125Z"
                      fill="#5CC82A"
                    />
                  </svg>
                  <span>{{ allLanguageData.FoodDrinks }}: </span>
                  <div class="d-flex flex-wrap pt-2">
                    <div
                      v-for="(datafnb, indexf) in userSelectedFnBItems"
                      :key="indexf"
                      class="pb-2 food-list"
                    >
                      ( {{ datafnb.Qty }} X {{ datafnb.ItemName }} )
                    </div>
                  </div>
                </div>
                <hr class="m-0 mb-3 fade-line no-hover-effect" />
              </li>
            </ul>
          </div>
          <div class="d-flex justify-content-between align-items-center"></div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center details-header">
            <div @click="goBack()">
              <img
                src="@/assets/img/new-img/svg-img/back-arrow.svg"
                class=""
                width="30px"
              />
            </div>

            <div
              @click="showContent()"
              v-bind:class="langName == 'ar' ? 'mr-1' : 'ml-1'"
            >
              <h6 class="mb-0">INFO</h6>
            </div>
          </div>
          <div
            :class="displayContent ? 'd-block arrow-down' : 'd-none'"
            @click="showContent()"
          >
            <img
              src="@/assets/img/new-img/svg-img/arrow-down.svg"
              class=""
              width="30px"
            />
          </div>
          <div
            class="d-flex align-items-center w-100"
            :class="displayContent ? '' : 'justify-content-end'"
          >
            <h6
              class="font-weight-bold mb-0"
              v-bind:class="langName == 'ar' ? 'ml-2' : 'mr-2'"
            >
              {{ allLanguageData.Total }} :
              <span class="sar-symbol" style="font-size:16px">&#xe900;</span>
              {{ currFormat(totalAmount) }}
            </h6>
            <div :class="displayContent ? 'ml-auto' : ''">
              <button
                v-if="userSelectedFnBItems.length > 0"
                class="btn btn-checkout"
                @click="onSubmitfnbCheckOut"
              >
                {{ allLanguageData.Proceed }}
              </button>
              <button v-else class="btn btn-checkout" @click="skipFNB">
                {{ allLanguageData.Skip }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      id="quitBooking"
      ref="quitBooking"
      :title="allLanguageData.QuitBooking.title"
      class="ErModal light-red-color"
    >
      <img
        class="mx-auto d-block mt-4"
        src="@/assets/img/svg/alert-icon.svg"
        width="45"
        height="auto"
      />
      <h6 class="pt-3 mb-0 text-center font-weight-bold text-white">
        {{ allLanguageData.QuitBooking.Content1 }}
      </h6>
      <!-- <h6 class="pt-2 text-center font-weight-bold text-white">{{allLanguageData.ErrorModal.Content2}}!</h6> -->
      <div class="d-flex justify-content-center align-items-center">
        <div class>
          <b-button
            v-on:click="goBackHistory()"
            variant="default"
            :class="preimere == 'true' ? 'btn-proceed' : 'btn-green'"
            class="btn mt-4 mb-3"
            >{{ allLanguageData.QuitBooking.Btn }}</b-button
          >
        </div>
        <div class="px-2"></div>
        <div class>
          <b-button
            v-on:click="onClickNo()"
            variant="default"
            :class="preimere == 'true' ? 'btn-proceed' : 'btn-green'"
            class="btn mt-4 mb-3"
            >{{ allLanguageData.QuitBooking.Btn1 }}</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      id="sessionExpired"
      ref="sessionExpired"
      :title="allLanguageData.session_expired_title"
      class="ErModal light-red-color"
    >
      <img
        class="mx-auto d-block mt-4"
        src="@/assets/img/svg/alert-icon.svg"
        width="45"
        height="auto"
      />
      <h6 class="pt-3 mb-0 text-center font-weight-bold text-white">
        {{ allLanguageData.session_expired }}
      </h6>
      <!-- {{ allLanguageData.session_expired }} -->
      <!-- <h6 class="pt-2 text-center font-weight-bold text-white">{{allLanguageData.ErrorModal.Content2}}!</h6> -->
      <div class="d-flex justify-content-center align-items-center">
        <div class>
          <b-button
            v-on:click="goBackExpired()"
            variant="default"
            :class="preimere == 'true' ? 'btn-proceed' : 'btn-green'"
            class="btn mt-4 mb-3"
            >{{ allLanguageData.OK }}</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      id="errorModal"
      ref="errorModal"
      title="Booking Failed"
      class="ErModal light-red-color"
    >
      <img
        class="mx-auto d-block mt-4"
        src="@/assets/img/svg/alert-icon.svg"
        width="45"
        height="auto"
      />
      <h6 class="pt-3 mb-0 text-center font-weight-bold text-white">
        {{ this.errorMessage }}...
      </h6>

      <b-button
        @click="onClickOk()"
        variant="default"
        class="btn btn-green mt-4 mb-3"
        >{{ allLanguageData.ErrorModal.Btn }}</b-button
      >
    </b-modal>

    <!----Food and Drinks Popup--->
    <div class="emp_new_modal emp-loyalty-modal showtimes-popup">
      <b-modal
        hide-header-close
        hide-footer
        ref="foodanddrinks"
        id="foodanddrinks"
        size="lg"
        class="rules-country-popup fnb-section"
      >
        <template slot="modal-header">
          <div class="row w-100 align-items-center">
            <div class="pr-0 col-1 mb-3 mb-md-0">
              <div
                class="d-block bg-emp-red"
                style="height: 3px; width: 100%"
              ></div>
            </div>
            <div class="col-10">
              <h6 class="hiw-title font-weight-bold mb-0 text-center">
                {{ allLanguageData.FoodDrinks }}
              </h6>
            </div>
            <span @click="closeFnbPop" class="new-closeBtn">X</span>
          </div>
        </template>

        <div
          class="emp_new_modal_body px-3 py-lg-2 py-2"
          style="background: whitesmoke !important; color: unset !important"
        >
          <!--                -->
          <div
            v-if="groupedItems.length"
            v-for="(group, groupindex) in groupedItems"
            :key="groupindex"
            class="my-4 pt-2"
            ref="fnbSliderWrapper3"
          >
            <div class="fnb-title py-3 pl-3 ar-number">
              {{
                `${group.fc_category || group.p_fc_category} (${
                  group.items.length
                })`
              }}
            </div>

            <div
              class="fnb-items empire-slider fnb-slider modal-slider mt-4"
              v-if="!groupLoading"
            >
              <!-- slick -->
              <slick
                @reInit="handleReInit1"
                :ref="'fnbSlider1' + groupindex"
                :options="fnbSliderOptions()"
                :id="'fnbSlider1' + groupindex"
                class="fnbSlider1"
              >
                <div
                  v-for="(dataItems, indexitems) in group.items"
                  :key="indexitems"
                >
                  <div class="fnb-card py-3" :title="dataItems.Description">
                    <div class="fnb-img d-flex justify-content-center">
                      <img
                        v-if="dataItems.ThumbnailImage"
                        :src="dataItems.ThumbnailImage"
                        class="image img-fluid"
                      />
                      <img
                        v-else
                        src="@/assets/img/dummy_img.png"
                        class="image img-fluid"
                      />
                    </div>
                    <div class="fnb-content pt-2">
                      <p class="main-title ar-number three">
                        {{ dataItems.ItemName }}
                      </p>
                      <div class="grid-half">
                        <div class="fnb-amt ar-number">
                          <!-- {{ dataItems.Currency }} -->
                          <span v-html="dataItems.Currency"></span>
                          {{ currFormat(dataItems.Amount) }}
                        </div>
                        <div class="qty 1011">
                          <div
                            class="icon"
                            @click="
                              storeFnbItems(
                                dataItems,
                                'sub',
                                dataItems.fnbItemDataIndex,
                                dataItems.fnbItemDataItemsIndex
                              )
                            "
                          >
                            <a> -</a>
                          </div>
                          <div class="num ar-number">{{ dataItems.Qty }}</div>
                          <div
                            class="icon"
                            @click="
                              storeFnbItems(
                                dataItems,
                                'add',
                                dataItems.fnbItemDataIndex,
                                dataItems.fnbItemDataItemsIndex
                              )
                            "
                          >
                            <a> +</a>
                          </div>
                        </div>
                      </div>

                      <div class="" style="margin-top: 5px">
                        <div
                          class="fnb-amt ar-number"
                          style="
                            white-space: nowrap;
                            margin-top: 12px;
                            width: auto;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          "
                        >
                          {{ dataItems.Description }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slick>
            </div>

            <div
              class="d-flex col-12 mt-4 align-center justify-content-center center"
            >
              <button
                @click="closeFnbPop()"
                class="btn quickbook-btn px-5"
                style="color: white"
              >
                {{ "OK" }}
              </button>
            </div>
          </div>
          <!--                -->
        </div>
      </b-modal>
    </div>

    <!--Combo Item-->

    <b-modal
      hide-footer
      hide-header
      id="comboPackModal"
      ref="comboPackModal"
      class="light-red-color"
    >
      <CustomizeComboPack
        :title="temFoodItem.ItemName"
        :refId="'comboPackModal'"
        :comboIndex="SelectedComboIndex"
        :onSaveComboPack="onSaveComboPack"
        :ComboPackArray="ComboPackArray"
        :checkCustomization="checkCustomization"
        @onCloseCombPopup="onCloseCombPopup"
      />
    </b-modal>
    <b-modal
      hide-footer
      hide-header
      id="alternate-items-modal"
      ref="alternate-items-modal"
      class="light-red-color"
    >
      <AlternateItemModal
        :refId="'alternate-items-modal'"
        :onClickItem="storeFnbItems"
        :AlternateItemsIds="AlternateItemsIds"
        :isAlternateItemLoading="loadingObj['fnbAlternate']"
        :AllfnbItem="fnbItemData"
        @handleAlternativeItemChange="handleAlternativeItemChange"
        @isAlterNativeItemselected="isAlterNativeItemselected"
      />
    </b-modal>
  </div>
</template>

<script>
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
// import { groupBy, orderBy } from "lodash";
import _ from "lodash";
import { EventBus } from "@/main";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import { URL_BASE } from "@/helper/constant";
import OtpInput from "@/components/OTP/OtpInput.vue";
import CustomizeComboPack from "../../components/FnbPopup/CustomizeComboPack";
import AlternateItemModal from "../../components/FnbPopup/AlternateItemModal";

import {
  LanguageService,
  CountryService,
  TokenService
} from "@/services/storage.service";

export default {
  components: {
    OtpInput,
    CustomizeComboPack,
    AlternateItemModal
  },
  beforeCreate: function() {
    let pre = window.localStorage.getItem("PREIMERE");
    if (pre == null || pre == "false" || pre == false) {
      document.body.className = "seatlayout-section";
    } else {
      document.body.className = "gold-black-bg";
    }
  },

  name: "FNBSelection",

  metaInfo: {
    title: "Seatlayout",
    titleTemplate: null
  },
  data() {
    return {
      showTotalFNBItemsCountInCombo: 0,
      mainAlterNativeItem: {},
      showSelectedBtnOnAlternativeItem: false,
      // isAlterNativeItemselected: [],
      loadingObj: {
        fnbloading: false,
        fnbCategory: false,
        fnbAlternate: false,
        fnbCustomization: false
      },
      onSaveComboFuncHit: false,
      tempFnbItemDataItemsIndex: 0,
      temFnbItemDataIndex: 0,
      tempType: "",
      AlternateItemsIds: [],
      temFoodItem: [],
      SelectedComboIndex: null,
      ComboPackArray: [],
      tempItem: [],
      alreadySelectedFnb: [],
      tempSelectedFnb: [],
      fnbloading: false,
      groupLoading: false,
      groupedItems: { length: 0 },
      URL_BASE_IMG: URL_BASE + "/",
      step: 0,
      isOfferAppliedId: null,
      displayContent: false,
      FnbSelected: "all",
      offerDetailsSection: [],
      normalOfferApplied: false,
      bankOfferApplied: false,
      normalOfferAppliedIndex: null,
      bankOfferAppliedIndex: null,
      cardInputErrorMsg: "",
      cardInputsuccessMsg: "",
      offerAppliedDetails: [],
      offerName: "",
      offerAppliedSuccessfully: false,
      promoAppliedSuccessfully: false,
      isRedeemSuccessfully: false,
      CheckLoyaltyIfNotLogin: "",
      appliedOfferType: null,
      otherOfferCards: false,
      isNewOfferClick: false,
      offerNotApplied: null,
      wc_seats: "",
      normal_seats: [],
      EmpisPremium: false,
      SeatLable: "",
      promoCodeValue: "",
      Discountmark: "",
      offerAmount: 0,
      redeemDiscount: 0,
      comboOfferAmount: 0,
      firstCardValue: "",
      lastCardValue: "",
      newfvvTest: "",
      FvvText: "",
      TotalfvvAmt: 0,
      discountedAmount: 0,
      IscomboOffer: null,
      offerData: [],
      preimere: false,
      BASEURL: URL_BASE,
      ConfirmationURL: "",
      FailedURL: "",
      userDetails: {},
      show: false,
      cinemaDetails: {},
      // Timer
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false
      },
      alpha: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"],
      seatLayout: [],
      seatTypes: [],
      countryData: {},
      sectionName: {
        selectNoOfSeats: true,
        seatLayout: true,
        foodAndBeverages: false,
        checkout: false,
        showFooter: true,
        offerSectionShow: false
      },

      paymentModal: {
        editContactDetails: false,
        viewContactDetails: true,
        wallet: false
      },
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      errorMessage: "",
      selectedSeats: [],
      selectedSeatsNew: "",

      discount: 0,
      movieDetails: {},
      foodAndBeverages: {
        listing: [],
        status: false,
        selected: [],
        allListing: [],
        selectedCategory: "All"
      },
      //  selectedCategory: LanguageID == '1' && LanguageID == 1 ? 'الكل' : 'All',
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ],
      isofferTabDisplay: 0,
      isCancelledSuccessfully: false,
      FoodNAMessage: "",
      FoodNAStatus: true,
      fnbtotal: 0,

      amount: 0,
      total_internet_handling_amt: 0,
      internethandling: 0,
      total_ticket_fnb: 0,
      currency: "",
      ReserveID: "",
      bookingID: "",
      reserveID: "",
      cinemaID: "",
      LanguageID: "",
      CountryID: "",
      CinemaType: "",
      FnbUrl: "",
      maxNumberofSeats: 10,
      offerPopInfo: [],
      numberOfRowArr: 0,
      BankOffersList: [],
      offerFilterTabs: [{ Type: "All", CouponID: 0 }],
      Alloffers: [],
      VoucherAllData: [],
      newAllOffers: [],
      isOfferDetails: false,
      newOfferSelected: [],
      userAlredyLogin: true,
      otpVerifyLoyalty: "",
      otpVerifyLoyaltyError: "",
      CheckLoyaltyApplicable: [],
      PointsRedeem: "",
      showMobileEnable: true,
      showOTPLoality: false,
      loyalityPopUpMessage: "",
      successLoyality: "",
      otpVerifyMobile: "",
      showSuccessRedeemtion: false,

      // New Starts here
      fnbItemData: [],
      fnbItemDataTemp: [],
      filteredfnbItemDataTemp: [],
      userSelectedFnBItems: [],
      totalAmount: 0,
      scheduleData: {
        CinameName: "",
        MovieTitle: "",
        ScreenName: "",
        ShowDate: "",
        ShowTime: "",
        Location: "",
        Experience: "",
        Currency: "",
        SeatName: "",
        SchID: ""
      },
      FNbPrice: { total_price: 0, total_tax: 0 },
      isSeatReleased: true,
      reservationDetails: null,
      add_ons_total: 0,
      add_ons_array: []
    };
  },

  // watch: {
  //   EmpisPremium: function(Value) {
  //     if (Value == true) {
  //       console.log("inside if");
  //       let finalArr = [];

  //       this.filterdfnbItemData.map((x) => {
  //         x.items.map((y) => {
  //           if (y.FnbDetail.is_premier_item === "Y") {
  //             finalArr.push(x);
  //           }
  //         });
  //       });
  //       console.log(finalArr, "finalArr");
  //     }
  //     console.log("outside if");
  //   },
  // },
  computed: {
    filterdfnbItemData() {
      let data = this.fnbItemData; // JSON.parse(JSON.stringify(this.fnbItemDataTemp))
      let tempdata = this.fnbItemDataTemp;

      data = data.map(x => {
        let tempArr = x.items.sort((a, b) => {
          if (a.fi_order === null) return 1;
          if (b.fi_order === null) return -1;
          if (a.fi_order === b.fi_order) return 0;
          return a.fi_order < b.fi_order ? -1 : 1;
        });
        x["items"] = tempArr;

        return x;
      });

      // console.log(data, "dataaaaa");

      if (this.EmpisPremium) {
        tempdata.map(x => {
          let tempnewArr = [...x.items];

          x["items"] = tempnewArr.filter(y => {
            return y.FnbDetail.is_premier_item == "Y";
          });
        });
        this.fnbItemDataTemp = tempdata.filter(t => {
          return t.items.length;
        });
        // console.log(this.fnbItemDataTemp, "tempdata");
        // this.fnbItemDataTemp = this.fnbItemDataTemp.filter(
        //   (r) => r.items.length
        // );
        // this.filteredfnbItemDataTemp = tempdata.filter((x) => {
        //   return x.items.length > 0;
        // });
        // console.log(this.filteredfnbItemDataTemp, "filteredfnbItemDataTemp");
        // let finalArr = [];
        data.map(x => {
          let newArr = [...x.items];

          x["items"] = newArr.filter(y => {
            return y.FnbDetail.is_premier_item == "Y";
          });
        });
        // console.log(data, "after_Premium");
        // data.forEach((fnb, fnb_index) => {
        //   fnb.fnbItemDataIndex = fnb_index;
        //   fnb.items.forEach((item, item_index) => {
        //     item.Qty = 0;
        //     item.fnbItemDataIndex = fnb_index;
        //     item.fnbItemDataItemsIndex = item_index;
        //   });
        // });
        data = data.filter(t => {
          return t.items.length;
        });

        // data = [...finalArr];
        // console.log(finalArr, "finalArr");

        // const filteredItems = this.fnbItemData.reduce((result, item) => {
        //   const premierItems = item.items.filter(
        //     (subItem) => subItem.FnbDetail.is_premier_item === "Y"
        //   );
        //   if (premierItems.length > 0) {
        //     result.push({
        //       ...item,
        //       items: premierItems.map((subItem) => subItem.FnbDetail),
        //     });
        //   }
        //   return result;
        // }, []);

        // filteredItems.forEach((fnb, fnb_index) => {
        //   // fnb.fnbItemDataIndex = fnb_index;
        //   fnb.items.forEach((item, item_index) => {
        //     item.Qty = 0;
        //     item.fnbItemDataIndex = fnb_index;
        //     item.fnbItemDataItemsIndex = item_index;
        //   });
        // });

        // filteredItems.forEach((fnb, fnb_index) => {
        //   fnb.fnbItemDataIndex = fnb_index;
        //   fnb.items.forEach((item, item_index) => {
        //     item.fnbItemDataIndex = fnb_index;
        //     item.fnbItemDataItemsIndex = item_index;
        //   });
        // });
        // console.log(filteredItems, "filteredItems");
        // return [...filteredItems];
      }

      if (!this.FnbSelected || this.FnbSelected == "all") {
        return (data = _.orderBy(data, "fc_order", "asc"));
      }

      let filtered = data
        .map(x => x)
        .filter(x => String(x.Id) === String(this.FnbSelected));

      return filtered;
    },
    // sortedFnbItemArray() {
    //   let sortedData = this.fnbItemData.map((x) => {
    //     return x.items;
    //   });
    //   sortedData = _.sortBy(sortedData, ["fc_order", "fi_order"]);
    //   console.log(sortedData, "sortedData");
    //   return sortedData;
    // },
    PointsRedeemRound() {
      let round =
        this.PointsRedeem / this.CheckLoyaltyApplicable[0].conversionpointvalue;
      return round;
    },

    isMaximumPointRedeem() {
      let pointTotal =
        this.total_ticket_fnb *
        this.CheckLoyaltyApplicable[0].conversionpointvalue;
      if (this.PointsRedeem > pointTotal) {
        return true;
      } else {
        return false;
      }
    },

    isMaximumCurrentPointRedeem() {
      // console.log(
      //   "this.CheckLoyaltyApplicable[0].BalancePoint",
      //   this.CheckLoyaltyApplicable[0].BalancePoint
      // );
      // console.log("this.PointsRedeem", this.PointsRedeem);
      // console.log(
      //   "this.CheckLoyaltyApplicable[0].BalancePoint < this.PointsRedeem",
      //   this.CheckLoyaltyApplicable[0].BalancePoint < this.PointsRedeem
      // );
      if (this.CheckLoyaltyApplicable[0].BalancePoint < this.PointsRedeem) {
        return true;
      } else {
        return false;
      }
    },

    PointsRedeemRoundTotal() {
      let round = this.CheckLoyaltyApplicable[0].PointsRedeem;
      return round;
    },
    checKApplyDisable() {
      if (this.CheckLoyaltyApplicable.length > 0) {
        if (
          parseInt(this.PointsRedeem) >=
            parseInt(this.CheckLoyaltyApplicable[0].MinPoints) &&
          parseInt(this.PointsRedeem) <=
            parseInt(this.CheckLoyaltyApplicable[0].BalancePoint)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    offerTabDisable() {
      return this.promoAppliedSuccessfully && this.appliedOfferType == 3;
    },

    voucherTabDisable() {
      return this.offerAppliedSuccessfully && this.appliedOfferType == 0;
    },

    // loyaltyTabDisable() {
    //   return (
    //     (!this.promoAppliedSuccessfully || !this.offerAppliedSuccessfully) &&
    //     this.isRedeemSuccessfully
    //   );
    // },
    isCardNumCorrect() {
      if (
        String(this.firstCardValue).length == 6 &&
        String(this.lastCardValue).length == 4
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  destroyed() {
    clearInterval(this.timerStartFunction);
  },
  beforeMount() {
    this.ReserveID = this.$route.params.reserveId;
    this.getReserveInfo();
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSeatReleased) {
      this.callSeatReleased();
    }
    next();
  },
  mounted: function() {
    let token = TokenService.getToken();
    if (token) {
      this.userAlredyLogin = false;
    } else {
      this.userAlredyLogin = true;
    }
    EventBus.$on("getCheckLoyality", e => {
      this.getCheckLoyalityApplicable(this.reserveID, this.theatreID);
    });
    let language = LanguageService.getLanguage();
    let country = CountryService.getCountry();

    // countryid
    if (!country) {
      this.CountryID = 119;
    } else {
      this.CountryID = country.CountryID;
    }
    // languageid
    if (!language) {
      this.LanguageID = 2;
    } else {
      this.LanguageID = language.lang_id;
    }

    this.preimere = window.localStorage.getItem("PREIMERE");
    // premiere type
    if (this.preimere == true || this.preimere == "true") {
      this.CinemaType = "premiere";
    } else {
      this.CinemaType = "normal";
    }
    EventBus.$on("paymentCompletionEvent", user => {
      this.paymentConfirmation();
    });
    EventBus.$on("checkOutEvent", userDetails => {
      this.checkout(userDetails);
    });
    window.addEventListener("message", function(e) {
      if (e.data === "sb:bn:loaded") {
        EventBus.$emit("paymentCompletionEvent", e);
      }
    });
  },
  methods: {
    clearAllFnbItems() {
      this.userSelectedFnBItems = [];
      this.fnbItemData.map(category => {
        if (category.items) {
          category.items.map(item => {
            if (item.Qty != 0) {
              item.Qty = 0;
            }
          });
        }
      });
    },
    onCloseCombPopup(isClosed) {
      // console.log("Popup closed:", isClosed);
      if (isClosed) {
        this.$refs["comboPackModal"].hide();
      }
    },
    handleAlternativeItemChange(emitPayload) {
      // console.log(emitPayload, "from parent emitPayload");
      let alternateFootitem = emitPayload.foodItem;
      let alternateType = emitPayload.type;
      let alternatefnbItemDataIndex = emitPayload.fnbItemDataIndex;
      let alternatefnbItemDataItemsIndex = emitPayload.fnbItemDataItemsIndex;
      this.storeFnbItems(
        alternateFootitem,
        alternateType,
        alternatefnbItemDataIndex,
        alternatefnbItemDataItemsIndex
      );
      // this.fetchOffers()
    },
    isAlterNativeItemselected(data) {
      // console.log(data, "objjjjjj");
      if (data && data.lenght > 0) {
        this.showSelectedBtnOnAlternativeItem = true;
      }

      // this.isAlterNativeItemselected = obj
      // this.fetchOffers()
    },
    checkCustomization() {
      if (this.SelectedComboIndex || this.SelectedComboIndex == 0) {
        let payload = _.cloneDeep(
          this.SelectedFnbItemList[this.SelectedComboIndex]
        );
        // if (
        //   payload &&
        //   payload.is_customization_available &&
        //   payload.customization_items &&
        //   payload.customization_items.length &&
        //   payload.is_customization_available == "Y"
        // ) {
        //   this.onFetchCustomizations({
        //     itemArray: payload.customization_items,
        //     index: this.SelectedComboIndex,
        //     item_id: payload.item_id,
        //   });
        // }
      }
    },
    onSaveComboPack(payload) {
      // console.log(payload, "payloadpayload");
      this.fnbItemData[this.temFnbItemDataIndex].items[
        this.tempFnbItemDataItemsIndex
      ]["final_combo_array"] = _.cloneDeep(payload.finalComboPack);

      this.fnbItemData[this.temFnbItemDataIndex].items[
        this.tempFnbItemDataItemsIndex
      ]["combo_pack"] = _.cloneDeep(payload.combo_pack);

      // console.log(this.temFoodItem, " this.temFoodItem");
      // console.log(this.tempType, "   this.tempType");

      // console.log(this.temFnbItemDataIndex, " this.temFnbItemDataIndex");

      // console.log(
      //   this.tempFnbItemDataItemsIndex,
      //   " this.tempFnbItemDataItemsIndex"
      // );
      this.addFnb(
        this.temFoodItem,
        this.tempType,
        this.temFnbItemDataIndex,
        this.tempFnbItemDataItemsIndex
      );
      // this.onSaveComboFuncHit = true;
      // this.storeFnbItems(
      //   this.temFoodItem,
      //   this.tempType,
      //   this.temFnbItemDataIndex,
      //   this.tempFnbItemDataItemsIndex
      // );

      this.$refs["comboPackModal"].hide();
      // this.SelectedFnbItemList[payload.orderIndex][
      //   "final_combo_array"
      // ] = _.cloneDeep(payload.finalComboPack);
      // this.SelectedFnbItemList[payload.orderIndex]["combo_pack"] = _.cloneDeep(
      //   payload.combo_pack
      // );
    },
    async onFetchAlternateItems(payload) {
      let obj = {
        item_id: payload.item_id
      };
      this.loadingObj["fnbAlternate"] = true;
      this.showLoading();

      try {
        const response = await makeRequestBrij(
          `/api/external/alternateitemsforWebsite/${obj.item_id}/${
            this.cinemaID
          }`,
          "GET",
          null,
          null
        );

        await this.hideLoading();
        // console.log(response, "response");
        const data = response.res.data;
        // console.log(data, "dataaaaaaaa");

        if (data && data.status && data.Records) {
          // console.log("Inside dataaaaaaaaaaa");
          let AlternateItems = data.Records;
          this.AlternateItemsIds = AlternateItems.map(x => x.alternate_fnb_id);
          // console.log("Above refffffff");
          await this.$refs["alternate-items-modal"].show();
        } else {
          this.$toasted.show(data.message || "No Alternative Items");
        }
      } catch (err) {
        this.hideLoading();
        console.log("Error:", err);
      } finally {
        this.loadingObj["fnbAlternate"] = false;
      }
    },

    onCustomizeCombo(order, orderIndex) {
      // console.log(order, "order");
      // console.log(orderIndex, "orderIndex");

      this.ComboPackArray = [];
      if (order.hasOwnProperty("combo_pack") && order.combo_pack.length > 0) {
        // console.log("onCustomizeCombo func");
        this.SelectedComboIndex = orderIndex;
        this.ComboPackArray = _.cloneDeep(order.combo_pack);
        if (this.ComboPackArray && this.ComboPackArray.length > 0) {
          this.showTotalFNBItemsCountInCombo = this.ComboPackArray.map(data => {
            return data.combo_items.length;
          }).reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          );
        }
        // console.log(this.$bvModal, "this.$bvModal");
        // console.log(this.$refs, "this.$refs");
        // this.onSaveComboFuncHit = true;
        // this.$bvModal.show("comboPackModal");
        this.$refs["comboPackModal"].show();
      }
    },
    fnbGrossAmount() {
      let amount = 0;
      if (this.SelectedFnbItemList.length > 0) {
        amount = this.SelectedFnbItemList.reduce(
          (accumulator, { fp_total_amount, quantity }) =>
            accumulator +
            parseFloat(fp_total_amount || 0) * parseFloat(quantity || 1),
          0
        );
      }
      return amount;
    },
    updateFnbCartItems(fnbItems = []) {
      this.alreadySelectedFnb = [];
      this.tempSelectedFnb = fnbItems || [];
      let amount = 0;
      if (fnbItems && fnbItems.length) {
        amount = fnbItems.reduce(
          (accumulator, { fp_total_amount, quantity }) =>
            accumulator +
            parseFloat(fp_total_amount || 0) * parseFloat(quantity || 1),
          0
        );
        this.totalAmount += +parseFloat(parseFloat(amount)).toFixed(4);
        fnbItems.forEach(z => {
          let obj = {
            Category: z.cat_id, // z.fc_id,
            fi_order: z.fi_order,
            ItemName: z.item_name,
            alternate_item_name: z.alternate_lang_item_name
              ? z.alternate_lang_item_name
              : z.item_name,
            Amount: z.fp_total_amount,
            // Currency: this.$store.getters.getGlobalCurrency.curr_code || "Sar",
            Currency:
              '<span class="sar-symbol" style="font-size:12px">&#xe900;</span>',
            Description: z.item_description,
            ThumbnailImage: z.item_image_url,
            Qty: z["quantity"] || 1,
            Id: z.item_id,
            TotalAmount: z.fp_total_amount,
            FnbDetail: { ...z },
            order: z.p_fc_order || z.fc_order || 1999
          };
          this.alreadySelectedFnb.push(obj);
          this.userSelectedFnBItems.push(obj);
        });
      }
    },
    sortFnbItemArr(itemArr = []) {
      return itemArr.sort((a, b) => a.fi_order - b.fi_order);
    },
    // sortArrays() {
    //   let sortVar = _.orderBy(this.fnbItemDataTemp, "Title", "asc");
    //   console.log(sortVar, "Sorted Array");
    //   return sortVar;
    // },
    openFnbPop() {
      this.$refs["foodanddrinks"].show();
    },
    closeFnbPop() {
      this.$refs["foodanddrinks"].hide();
    },
    closeComboPop() {
      this.$refs["comboPopup"].hide();
    },
    getCinemaTranslatedName(cinema) {
      if (!cinema) return "";

      let name =
        this.getLangSpecificAttribute(
          cinema.translation_data || [],
          this.getCurrentLang().brij_lang_id,
          "cinema_name",
          "langaugeId"
        ) || cinema.cinema_name;

      return name;
    },
    selectedItems() {
      let selectedItem = [];
      this.fnbItemData.map(z => {
        z.items.map(_it => {
          if (_it.Qty > 0) {
            // console.log("fnbItemData if is working");
            let TotalPrice =
              +parseFloat(_it.FnbDetail.fp_total_amount).toFixed(4) * _it.Qty;
            let TotalTax =
              +parseFloat(
                _it.FnbDetail.fp_total_amount - _it.FnbDetail.fp_amount
              ).toFixed(4) * _it.Qty;

            this.FNbPrice["total_price"] = +parseFloat(
              this.FNbPrice["total_price"] + TotalPrice
            ).toFixed(4);
            this.FNbPrice["total_tax"] = +parseFloat(
              this.FNbPrice["total_tax"] + TotalTax
            ).toFixed(4);
            let obj = {
              // ..._it.FnbDetail,
              Quantity: _it.Qty,
              quantity: _it.Qty,
              Qty: _it.Qty,
              qty: _it.Qty,
              total_price: TotalPrice,
              total_tax: TotalTax,
              item_name: _it.ItemName || "",
              item_id: _it.Id || _it.FnbDetail.item_id || "",
              item_code: _it.FnbDetail.item_code || "",
              alternate_lang_item_name: _it.alternate_item_name || "",
              fp_total_amount: _it.FnbDetail.fp_total_amount || 0,
              is_combo: _it.is_combo || "N",
              is_premier_item: _it.is_premier_item || "N",
              ready_to_serve: _it.ready_to_serve || "N",
              final_combo_array: _it.final_combo_array || [],
              has_modifiers: _it.has_modifiers || "N",
              final_modifier_array: _it.final_modifier_array || [],
              combo_pack: _it.combo_pack || []
            };
            selectedItem.push(obj);
          }
        });
      });

      if (this.tempSelectedFnb && this.tempSelectedFnb.length) {
        // console.log("tempSelectedFnb if is working");
        this.tempSelectedFnb.forEach(_item => {
          let obj = {
            ..._item,
            Quantity: _item.quantity,
            total_price: +parseFloat(_item.quantity * _item.fp_total_amount),
            total_tax: +parseFloat(
              _item.quantity * (_item.fp_total_amount - _item.fp_amount)
            )
          };
          selectedItem.push(obj);
        });
      }
      // console.log(selectedItem, "selectedItemselectedItem");
      return selectedItem;
    },
    getTitleIndex(id) {
      this.fnbloading = true;
      this.showLoading();

      this.FnbSelected = id;

      setTimeout(() => {
        this.fnbloading = false;
        this.hideLoading();
      }, 100);
    },
    goBackExpired() {
      this.onClickOk();
    },
    handleReInit(e, s) {
      console.log("handleReInit", e, s);
      this.$refs.fnbSlider.forEach(item => {
        item.slick("unslick");
        item.slick(this.fnbSliderOptions());
      });
    },
    handleReInit1(e, s) {
      console.log("handleReInit", e, s);
      this.$refs.fnbSlider1.forEach(item => {
        item.slick("unslick");
        item.slick(this.fnbSliderOptions());
      });
    },
    getReserveInfo() {
      this.hideLoading();
      let payload = {};
      this.showLoading();
      makeRequestBrij(
        `/api/external/reservation-detail/${this.ReserveID}`,
        "GET",
        null,
        null
      )
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;

          if (!error) {
            if (res.data && res.data.status) {
              let schedule_detail = res.data.Records[0];
              this.reservationDetails = res.data.Records[0];
              // console.log("schedule_detail");
              this.scheduleData = {
                CinameName:
                  this.getCinemaTranslatedName(schedule_detail) ||
                  schedule_detail.cine_name,
                MovieTitle:
                  this.getLangSpecificAttribute(
                    schedule_detail.altMovieContent,
                    this.getCurrentLang().brij_lang_id,
                    "mc_title"
                  ) ||
                  schedule_detail.movie_title ||
                  schedule_detail.original_title_of_movie,
                ScreenName: schedule_detail.screen_name,
                ShowDate: moment(schedule_detail.ss_actual_start_date)
                  .locale(this.getCurrentLang().iso_2 || "en")
                  .format("ddd, DD MMM YYYY"),
                ShowTime: moment(schedule_detail.ss_start_show_time, "HH:mm")
                  .locale(this.getCurrentLang().iso_2 || "en")
                  .format("hh:mm A"),
                Location: schedule_detail.cine_address,
                Experience: schedule_detail.mf_name,
                // Currency:
                //   this.$store.getters.getGlobalCurrency.curr_code || "Sar",
                Currency:
                  '<span class="sar-symbol" style="font-size:12px">&#xe900;</span>',
                SeatName: "",
                SchID: schedule_detail.ss_id
              };
              if (schedule_detail.mf_name.includes("EMPIRE PREMIERE")) {
                this.EmpisPremium = true;
              }

              // console.log(this.EmpisPremium, "this.EmpisPremium");
              if (
                schedule_detail.hasOwnProperty("cinema_id") &&
                schedule_detail.cinema_id
              ) {
                this.cinemaID = schedule_detail.cinema_id;
              }
              if (schedule_detail.add_ons_array.length) {
                this.add_ons_array =
                  schedule_detail.add_ons_array[0].gross_amount_addons_on_ticket;
                if (this.add_ons_array && this.add_ons_array.length > 0) {
                  this.add_ons_array.map(z => {
                    if (z.is_additional_price_on_ticket == "Y") {
                      this.add_ons_total += z.final_price;
                    }
                  });
                }
                // quantity //addons_name //final_price
              }
              if (
                schedule_detail.hasOwnProperty("selectedSeats") &&
                schedule_detail.selectedSeats.length > 0
              ) {
                this.selectedSeatsNew = schedule_detail.selectedSeats;

                let seatName = [];
                this.selectedSeatsNew.map((x, index) => {
                  let obj = {
                    sst_seat_type: x.sst_seat_type,
                    screen_seat_type_id: x.screen_seat_type_id,
                    seatName:
                      x.seat_reserve_type_id != "3" ? [x.sl_seat_name] : [],
                    wheelChair:
                      x.seat_reserve_type_id == "3" ? [x.sl_seat_name] : []
                  };
                  let findIndex = seatName.findIndex(z => {
                    return z.screen_seat_type_id == x.screen_seat_type_id;
                  });
                  if (findIndex >= 0) {
                    if (x.seat_reserve_type_id == "3") {
                      seatName[findIndex]["wheelChair"].push(x.sl_seat_name);
                    } else {
                      seatName[findIndex]["seatName"].push(x.sl_seat_name);
                    }
                  } else {
                    seatName.push(obj);
                  }
                });

                // console.log(seatName, "selectedSeatsNew");
                this.normal_seats = seatName;
                // if (seatName[0].sst_seat_type.includes("PREMIUM")) {
                //   return this.isPremium == true;
                // }

                if (schedule_detail.amount) {
                  this.totalAmount = +schedule_detail.amount.toFixed(4);
                }

                this.totalAmount = this.add_ons_total + this.totalAmount;

                this.timer.minutes = schedule_detail.timer_minutes;
                this.timer.seconds = schedule_detail.timer_second;
                this.startTimer();
              }

              if (
                schedule_detail.hasOwnProperty("fnb_data") &&
                schedule_detail.fnb_data &&
                schedule_detail.fnb_data.hasOwnProperty("selected_fnb_items") &&
                schedule_detail.fnb_data.selected_fnb_items.length > 0
              ) {
                this.updateFnbCartItems(
                  schedule_detail.fnb_data.selected_fnb_items
                );
              }
              this.hideLoading();

              this.getfnbDataBrij();
            } else {
              setTimeout(() => {
                this.$refs["errorModal"].show();
                this.errorMessage = res.data.message;
                this.hideLoading();
              });
            }
          } else {
            console.log("object");
          }
        })
        .catch(error => {
          this.hideLoading();

          console.log("error", error);
        });
    },
    fnbSliderOptions() {
      return {
        arrows: true,
        dots: false,
        infinite: true,
        slidesToScroll: 3,
        slidesToShow: 3,
        lazyLoad: "ondemand",
        setPosition: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              adaptiveHeight: true,
              arrows: true
            }
          }
        ]
      };
    },
    handleSetPosition(event, slick) {
      console.log(event, slick);
    },
    selectCategoryGroup(group, index, groupedItems) {
      this.groupLoading = true;
      this.groupedItems = groupedItems.filter((_, i) => index == i);
      // popup here
      this.openFnbPop();

      console.log({ group, index, groupedItems });

      setTimeout(() => {
        this.groupLoading = false;
      });
    },
    addFnb(foodItem, type, fnbItemDataIndex, fnbItemDataItemsIndex) {
      if (type == "add") {
        let selecteditem = this.fnbItemData[fnbItemDataIndex].items.filter(
          x => {
            return x.Id == foodItem.Id;
          }
        );
        if (selecteditem.length > 0) {
          if (selecteditem[0].Qty < 10) {
            this.fnbItemData[fnbItemDataIndex].items[
              fnbItemDataItemsIndex
            ].Qty += 1;
            this.totalAmount = +parseFloat(
              parseFloat(this.totalAmount) + parseFloat(selecteditem[0].Amount)
            ).toFixed(4);
          }
        }
      }
      if (type == "sub") {
        let selecteditem = this.fnbItemData[fnbItemDataIndex].items.filter(
          x => {
            return x.Id == foodItem.Id;
          }
        );
        if (selecteditem.length > 0 && selecteditem[0].Qty != 0) {
          this.fnbItemData[fnbItemDataIndex].items[
            fnbItemDataItemsIndex
          ].Qty -= 1;

          this.totalAmount = +parseFloat(
            parseFloat(this.totalAmount) - parseFloat(selecteditem[0].Amount)
          ).toFixed(4);
          // console.log(selecteditem, "ki");
        }
      }
      this.userSelectedFnBItems = [];
      // this.fnbQty = 0;
      this.fnbItemData.map(category => {
        if (category.items) {
          category.items.map(item => {
            if (item.Qty != 0) {
              let obj = {
                Id: item.Id,
                Qty: item.Qty,
                ItemName: item.ItemName
              };
              this.userSelectedFnBItems.push(obj);
            }
          });
        }
      });

      // console.log({
      //   foodItem,
      //   type,
      //   fnbItemDataIndex,
      //   fnbItemDataItemsIndex,
      // });

      // console.log(this.fnbItemData, "onCLic");
      this.$forceUpdate();
    },
    storeFnbItems(foodItem, type, fnbItemDataIndex, fnbItemDataItemsIndex) {
      // console.log(foodItem, "foodItem");
      this.temFoodItem = foodItem;
      this.tempType = type;
      this.temFnbItemDataIndex = fnbItemDataIndex;
      this.tempFnbItemDataItemsIndex = fnbItemDataItemsIndex;
      let Items = foodItem.FnbDetail;
      if (
        Items.hasOwnProperty("is_combo") &&
        Items.is_combo == "Y" &&
        Items.combo_pack.length &&
        type == "add"
      ) {
        this.tempItem = _.cloneDeep(Items);
        // console.log("Inside storeFnbItems");
        this.onCustomizeCombo(Items, fnbItemDataIndex);
      } else if (
        Items.hasOwnProperty("has_alternate_items") &&
        Items.has_alternate_items == "Y" &&
        type == "add"
      ) {
        this.mainAlterNativeItem = foodItem;
        // console.log("has_alternate_items");
        this.onFetchAlternateItems({
          item_id: foodItem.Id,
          index: fnbItemDataIndex
          // quantity: payload.quantity || 1,
        });
        // console.log("Outside Iffff isAlterNativeItemselected");
      } else {
        // console.log("Inside This");
        if (type == "add") {
          let selecteditem = this.fnbItemData[fnbItemDataIndex].items.filter(
            x => {
              return x.Id == foodItem.Id && foodItem.FnbDetail.is_combo == "N";
            }
          );
          if (selecteditem.length > 0) {
            if (selecteditem[0].Qty < 10) {
              this.fnbItemData[fnbItemDataIndex].items[
                fnbItemDataItemsIndex
              ].Qty += 1;
              this.totalAmount = +parseFloat(
                parseFloat(this.totalAmount) +
                  parseFloat(selecteditem[0].Amount)
              ).toFixed(4);
            }
          }
        }

        if (type == "sub") {
          let selecteditem = this.fnbItemData[fnbItemDataIndex].items.filter(
            x => {
              return x.Id == foodItem.Id;
            }
          );
          if (selecteditem.length > 0 && selecteditem[0].Qty != 0) {
            this.fnbItemData[fnbItemDataIndex].items[
              fnbItemDataItemsIndex
            ].Qty -= 1;

            this.totalAmount = +parseFloat(
              parseFloat(this.totalAmount) - parseFloat(selecteditem[0].Amount)
            ).toFixed(4);
            // console.log(selecteditem, "ki");
          }
        }
        this.userSelectedFnBItems = [];
        // this.fnbQty = 0;
        let selectedParentAlternativeItem = this.mainAlterNativeItem;

        // console.log("Inside showSelectedBtnOnAlternativeItem setting");

        this.fnbItemData.map(category => {
          if (category.items) {
            category.items.map(item => {
              if (item.Id == selectedParentAlternativeItem.Id) {
                item["showSelectedBtnOnAlternativeItem"] = true; // Use '=' for assignment
              } else {
                item["showSelectedBtnOnAlternativeItem"] = false; // Ensure others are set to false
              }
              if (item.Qty != 0) {
                let obj = {
                  Id: item.Id,
                  Qty: item.Qty,
                  ItemName: item.ItemName
                };
                this.userSelectedFnBItems.push(obj);
              }
            });
          }
        });

        // console.log({
        //   foodItem,
        //   type,
        //   fnbItemDataIndex,
        //   fnbItemDataItemsIndex,
        // });

        // console.log(this.fnbItemData, "onCLic");
        this.$forceUpdate();
      }
    },

    filterFnbItems(e) {
      this.showLoading();
      this.$refs.fnbSliderWrapper &&
        this.$refs.fnbSliderWrapper.map((item, index) => {
          const elementId = e.target.id;
          const elementIdLastChar = elementId.slice(
            elementId.length - 1,
            elementId.length
          );
          if (elementIdLastChar != 0) {
            if (elementIdLastChar != index + 1) {
              item.style.display = "none";
            } else {
              item.style.display = "block";
            }
          } else {
            item.style.display = "block";
          }
        });

      setTimeout(() => {
        this.hideLoading();
      }, 600);

      // if (selectedCat != "All") {
      //   let filteredFnbList = this.fnbItemDataTemp.filter(x => {
      //     return x.Id == data.Id;
      //   });

      //   if (filteredFnbList.length > 0) {
      //     this.fnbItemData = filteredFnbList;
      //   } else {
      //     this.fnbItemData = [];
      //   }
      // } else {
      //   this.fnbItemData = this.fnbItemDataTemp;
      // }
    },
    getfnbDataBrij() {
      this.showLoading();
      let payloadNew = {
        category: null,
        aggregator_cinema_id: this.cinemaID,
        cinema_id: this.cinemaID,
        isCombo: false,
        isEgg: "",
        isVeg: "",
        search: "",
        subCategory: null,
        // reservation_id: this.ReserveID || null,
        reservation_id: null
      };
      makeRequestBrij(`/api/external/fnb-items`, "POST", null, payloadNew).then(
        responseFnb => {
          this.hideLoading();
          if (responseFnb.res.data.Records.Records.length > 0) {
            let dataFnb = responseFnb.res.data.Records.Records;
            // console.log(dataFnb, "All data");
            let FNBItem = [];

            dataFnb.map(z => {
              let check = FNBItem.findIndex(_fnb => {
                return _fnb.Id == z.cat_id; // z.fc_id
              });
              if (check >= 0) {
                FNBItem[check]["itemcount"] = FNBItem[check]["itemcount"] + 1;
                let obj = {
                  Category: z.cat_id, // z.fc_id,
                  fi_order: z.fi_order,
                  ItemName: z.item_name,
                  alternate_item_name: z.alternate_lang_item_name
                    ? z.alternate_lang_item_name
                    : z.item_name,
                  Amount: z.fp_total_amount,
                  // Currency:
                  //   this.$store.getters.getGlobalCurrency.curr_code || "Sar",
                  Currency:
                    '<span class="sar-symbol" style="font-size:12px">&#xe900;</span>',
                  Description: z.item_description,
                  ThumbnailImage: z.item_image_url,
                  Qty: 0,
                  Id: z.item_id,
                  TotalAmount: z.fp_total_amount,
                  FnbDetail: { ...z },
                  order: z.p_fc_order || z.fc_order || 1999
                };

                FNBItem[check]["items"].push(obj);
              } else {
                // console.log(z, "from z");
                let obj = {
                  Id: z.cat_id, // z.fc_id,
                  Title: z.fc_category,
                  fc_order: z.fc_order,
                  alternate_language:
                    z.FnbCategoryContent[0].category_lang_name,

                  items: [
                    {
                      Category: z.cat_id, // z.fc_id,
                      ItemName: z.item_name,
                      alternate_item_name: z.alternate_lang_item_name
                        ? z.alternate_lang_item_name
                        : z.item_name,
                      fc_id: z.fc_id,
                      fi_order: z.fi_order,
                      Amount: z.fp_total_amount,
                      // Currency:
                      //   this.$store.getters.getGlobalCurrency.curr_code || "Sar",
                      Currency:
                        '<span class="sar-symbol" style="font-size:12px">&#xe900;</span>',
                      Description: z.item_description,
                      ThumbnailImage: z.item_image_url,
                      Qty: 0,
                      Id: z.item_id,
                      TotalAmount: z.fp_total_amount,
                      FnbDetail: { ...z }
                    }
                  ],
                  itemcount: 1
                };
                FNBItem.push(obj);
              }
            });

            console.log("FNBItem", FNBItem);
            // sorting sub items
            FNBItem.forEach(f => {
              f.items = f.items
                .map(z => z)
                .sort((a, b) => {
                  let comparison = a.Amount - b.Amount;

                  if (comparison === 0) {
                    comparison =
                      b.FnbDetail.fc_parent_id - a.FnbDetail.fc_parent_id;
                  }
                  if (comparison === 0) {
                    comparison = b.FnbDetail.fc_id - a.FnbDetail.fc_id;
                  }
                  if (comparison === 0) {
                    comparison = b.FnbDetail.cat_id - a.FnbDetail.cat_id;
                  }

                  return comparison;
                });
            });

            // sorting fnb items
            FNBItem = FNBItem.sort((a, b) => {
              let comparison = a.order - b.order;
              if (comparison === 0) comparison = a.Id - b.Id;

              return comparison;
            });

            // setting index
            FNBItem.forEach((fnb, fnb_index) => {
              fnb.fnbItemDataIndex = fnb_index;
              fnb.items.forEach((item, item_index) => {
                item.fnbItemDataIndex = fnb_index;
                item.fnbItemDataItemsIndex = item_index;
              });
            });

            // making groups of categories
            FNBItem.forEach(f => {
              let grp = this.groupByToMap(f.items, x =>
                JSON.stringify({
                  fc_id: x.FnbDetail.fc_id,
                  fc_parent_id: x.FnbDetail.fc_parent_id,
                  fc_category: x.FnbDetail.fc_category,
                  p_fc_category: x.FnbDetail.p_fc_category
                })
              );
              let grouped = [];
              for (const [key, value] of grp) {
                let category = JSON.parse(String(key));
                let items = [...value];
                let grpItems = { ...category, items };
                grouped.push(grpItems);
              }
              grouped.forEach((item, item_index) => {
                item.groupedItemsIndex = item_index;
              });
              f.groupedItems = grouped;
            });
            FNBItem.forEach(data => {
              return data.items.forEach(elem => {
                return (elem.showSelectedBtnOnAlternativeItem = false);
              });
            });
            this.fnbItemData = FNBItem;
            this.fnbItemDataTemp = FNBItem;

            // console.log(this.fnbItemData, "fnbItemData");
            this.fnbItemDataTemp = _.orderBy(
              this.fnbItemDataTemp,
              "fc_order",
              "asc"
            );
            // console.log(this.fnbItemDataTemp, "fnbItemDataTemp");
            // console.log(this.fnbItemDataTemp, "Fnb Test");
            // this.fnbItemDataTemp.sort((a, b) => {
            //   a.Title.localeCompare(b.Title);
            //   return this.fnbItemDataTemp;
            // });
            // fnbItemDataTemp.sort((a, b) => {
            //   const nameA = a.Title.toUpperCase(); // ignore upper and lowercase
            //   const nameB = b.Title.toUpperCase(); // ignore upper and lowercase
            //   if (nameA < nameB) {
            //     return -1;
            //   }
            //   if (nameA > nameB) {
            //     return 1;
            //   }

            //   // names must be equal
            //   return 0;
            // });
          }
        }
      );
    },
    skipFNB() {
      this.isSeatReleased = false;
      window.localStorage.setItem("MIN", this.timer.minutes);
      window.localStorage.setItem("SEC", this.timer.seconds);
      this.$store.commit("SET_ENABLE_CONFIRMATION_ACCESS", {
        status: true
      });
      this.$router.replace({
        path: "/ticket-confirmation/" + this.ReserveID
      });
    },
    onSubmitfnbCheckOut: function() {
      this.showLoading();
      let payload = {
        reservation_id: this.ReserveID,
        selected_fnb_items: this.selectedItems(),
        fnb_price: this.FNbPrice,
        category_id: 2
      };

      makeRequestBrij("/api/external/save-fnb-items", "POST", null, payload)
        .then(result => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.status) {
            this.hideLoading();
            this.skipFNB();
          } else {
            // show error modal
            this.$root.$emit("bv::show::modal", "errorModal");
          }
          this.hideLoading();
        })
        .catch(error => {
          this.hideLoading();
          console.log("Error on vue front", error);
        });
    },
    // old Flow
    userLogin() {
      EventBus.$emit("isUserNotLogin");
    },
    showContent() {
      this.displayContent = !this.displayContent;
    },

    // loyalty
    onClickRetry: function() {
      this.$refs.FoodNA.hide();
      this.FoodNAStatus = true;
    },
    onClickProceed: function() {
      this.$refs.FoodNA.hide();
      this.ReserveDetails();
    },
    changeNumberFormat(number) {
      return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onClickNo: function() {
      this.$refs.quitBooking.hide();
    },
    FromSubmit: function() {
      console.log("FromSubmit FromSubmit");
    },
    checkoutPopUp: function() {
      this.checkSignIn();
    },
    goBack() {
      this.$refs["quitBooking"].show();
    },

    goBackHistory() {
      this.onClickOk();
    },
    checkSignIn: function() {
      EventBus.$emit("getUserDetailsAndCheckout");
    },
    checkout: function(userDetails) {
      // Call payment function
      this.userDetails = userDetails;
      // this.updateBookUser();
      this.$forceUpdate();
      this.$nextTick(() => {
        this.updateBookUser();
      });
      // this.processPayment();
    },

    // OFFER PAGE OFFER REMOVE MODAL
    showOfferPageRemoveModal: function() {
      this.$root.$emit("bv::show::modal", "offerPageRemoved");
    },

    // CHECKOUT OFFER REMOVE MODAL
    showOfferRemoveModal: function() {
      this.$root.$emit("bv::show::modal", "offerRemoved");
    },

    closeOfferRemoveModal: function() {
      this.$root.$emit("bv::hide::modal", "offerRemoved");
      this.$root.$emit("bv::hide::modal", "offerPageRemoved");
    },
    /*
    getAllOffers (cinemaId, reserveId) {
      this.showLoading()
      console.log('cinemaId, reserveId', cinemaId, reserveId)
      let payload = {
        CinemaID: cinemaId,
        ReserveID: reserveId
      }
      makeRequest('/Offerlist', 'POST', null, payload)
        .then(result => {
          const { error, res } = result
          const { data } = res.data
          console.log('res.data', res.data)
          if (!error && res.data.Status) {
            this.newAllOffers = res.data
            if (res.data.VoucherData[0]) {
              this.VoucherAllData = res.data.VoucherData[0]
            }
            this.Alloffers = res.data.Offer
            // let array = ["All"];
            // this.offerFilterTabs = [...array, ...res.data.OfferType];
            res.data.OfferType.map(x => {
              this.offerFilterTabs.push(x)
            })
            // this.handleResize();
          } else {
            console.log('error')
          }
          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()

          console.log('error', error)
        })
    },
    */
    getFilterOffers(typeID, index) {
      this.step = index;
      // this.normalOfferAppliedIndex = -1;
      this.cardInputErrorMsg = "";
      this.cardInputErrorMsg = "";
      // this.offerDetailsBox = true;
      this.Alloffers = [];
      this.newAllOffers.Offer.map(x => {
        if (typeID == x.CouponID) {
          this.Alloffers.push(x);
        } else if (typeID == 0 || typeID == "0") {
          this.Alloffers.push(x);
        }
      });
      // this.handleResize();
    },

    editNumberOfSeats: function(number) {
      this.totalNumberOfSeats = number;
      this.sectionName.seatLayout = true;
      // deselect all
      this.selectedSeats.map(x => {
        this.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
        this.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
    },
    onSelectCategory: function(value) {
      this.foodAndBeverages.selectedCategory = value;
    },
    onSelectFoodItem(foodItem, type, index) {
      if (type == "add") {
        if (
          this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty < 10
        ) {
          this.foodAndBeverages.listing[foodItem.Category.Title][
            index
          ].Qty += 1;

          this.totalAmount = +parseFloat(
            parseFloat(this.totalAmount) + parseFloat(foodItem.Amount)
          ).toFixed(4);
        }
      }
      if (
        type == "subtract" &&
        this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty != 0
      ) {
        this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty -= 1;

        this.totalAmount = +parseFloat(
          parseFloat(this.totalAmount) - parseFloat(foodItem.Amount)
        ).toFixed(4);
      }

      this.foodAndBeverages.selected = [];
      this.fnbQty = 0;
      Object.keys(this.foodAndBeverages.listing).map(category => {
        this.foodAndBeverages.listing[category].map(item => {
          if (item.Qty != 0) {
            this.foodAndBeverages.selected.push(item);
          }
        });
      });
      this.foodAndBeverages.selected.map(fb => {
        this.fnbQty = parseInt(this.fnbQty) + parseInt(fb.Qty);
      });
    },
    /*
    getFoodAndBeverages: function () {
      let payload = {
        SchID: this.scheduleID,

        TransactionType: 'Normal'
      }

      makeRequest('/GetFnBItems', 'POST', null, payload)
        .then(result => {
          const { error, res } = result
          const { data } = res.data
          if (!error) {
            this.foodAndBeverages.listing = res.data.List
            this.foodAndBeverages.allListing = res.data.List
            this.foodAndBeverages.listing = groupBy(
              this.foodAndBeverages.listing,
              'Category.Title'
            )
          }
        })
        .catch(error => {
          console.log('Error on vue front', error)
        })
    },
    */
    callSeatReleased() {
      makeRequestBrij("/api/external/release-seat", "POST", null, {
        reservation_id: this.ReserveID
      }).then(result2 => {});
    },

    onClickOk: function() {
      this.$router.go(-1);
      this.$refs.errorModal.hide();
      this.$refs.quitBooking.hide();
      this.$refs.sessionExpired.hide();
    },

    onClickModalOk: function() {
      this.$refs.warningModal.hide();
      this.$refs.warningModalNew.hide();
    },

    startTimer: function() {
      this.timerStartFunction = setInterval(() => {
        this.timer.seconds =
          this.timer.seconds > 0 ? parseFloat(this.timer.seconds) - 1 : 0;

        if (parseFloat(this.timer.seconds) < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }

        if (parseFloat(this.timer.seconds) <= 0 && this.timer.minutes > 0) {
          this.timer.seconds = 59;
          this.timer.minutes =
            this.timer.minutes > 0 ? parseFloat(this.timer.minutes) - 1 : "00";
        }
        if (
          parseFloat(this.timer.minutes) == 0 &&
          parseFloat(this.timer.seconds) == 0
        ) {
          this.timer.seconds = "00";
          this.$refs["sessionExpired"].show();
          // this.$router.push({
          //   name: "cinemashowtimes",
          //   params: {
          //     movieId: "313",
          //     cat_id: "1",
          //     movieName: this.scheduleData.MovieTitle.replace(/ /g, "-")
          //   }
          // });
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          clearInterval(this.timerStartFunction);
          return false;
        } else {
        }
      }, 1000);
    },
    updateModalClass() {
      // Check the condition to add or remove class
      if (this.showTotalFNBItemsCountInCombo > 11) {
        $("#comboPackModal .modal-content").addClass("combo-dynamic-class");
      } else {
        $("#comboPackModal .modal-content").removeClass("combo-dynamic-class");
      }
    }
  },
  watch: {
    showTotalFNBItemsCountInCombo(newValue) {
      // Whenever the value of showTotalFNBItemsCountInCombo changes, update the class
      this.updateModalClass();
    }
  }
};
</script>
<style scoped>
.combo-dynamic-class {
  overflow-y: scroll;
  height: 700px;
  zoom: 0.85;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/fnbNew.vue